import orderViewInstance from '../instance'

const getOrdersUnpaid = (dateFrom, dateTo) => {
	return orderViewInstance.get('/orders/unpaid', { params: { dateFrom, dateTo } })
}

export default getOrdersUnpaid
